import { WaypointActionStatusName } from '@caresend/types';
import { isMailInAction, hasStatus } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__$1 from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__ from './ItineraryNonMailInWaypointActionCard.vue.js';
import __vue_component__$2 from '../../Workflow/InlineWorkflowItem.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';

var script = defineComponent({
    name: 'ItineraryWaypointCard',
    components: {
        ItineraryNonMailInWaypointActionCard: __vue_component__,
        BasicCard: __vue_component__$1,
        InlineWorkflow: __vue_component__$2,
    },
    props: {
        hideWorkflow: {
            type: Boolean,
            default: false,
        },
        inputDisabled: Boolean,
        isActionable: {
            type: Boolean,
            default: true,
        },
        waypointAction: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const portalStore = usePortalStore();
        const { viewAs } = portalStore;
        const mailInAction = computed(() => {
            if (isMailInAction(props.waypointAction))
                return props.waypointAction;
            return null;
        });
        const procedureIDs = computed(() => { var _a; return (Object.keys((_a = props.waypointAction.procedures) !== null && _a !== void 0 ? _a : {})); });
        const waypointID = computed(() => props.waypointAction.waypointID);
        const waypointAction = computed(() => portalStore.waypointActions.get(props.waypointAction.id));
        const workflowContexts = computed(() => { var _a, _b; return Array.from((_b = (_a = waypointAction.value) === null || _a === void 0 ? void 0 : _a.computed.workflowContexts) !== null && _b !== void 0 ? _b : []); });
        const workflows = computed(() => { var _a, _b, _c, _d; return (_d = (_b = (_a = waypointAction.value) === null || _a === void 0 ? void 0 : _a.computed.workflows) === null || _b === void 0 ? void 0 : _b[(_c = waypointID.value) !== null && _c !== void 0 ? _c : '']) !== null && _d !== void 0 ? _d : {}; });
        const isCanceled = computed(() => hasStatus(waypointAction.value, WaypointActionStatusName.CANCELED));
        return {
            isCanceled,
            mailInAction,
            procedureIDs,
            waypointID,
            workflowContexts,
            workflows,
            viewAs,
        };
    },
});

export { script as default };
